import type { LDFlagSet } from 'launchdarkly-js-sdk-common';
import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';

import { getManualOverrides } from './getManualOverrides';

export const useFlags = (): LDFlagSet => {
    const overrides = getManualOverrides();
    const ldFlags = useLDFlags();

    return { ...ldFlags, ...(overrides as LDFlagSet) } as LDFlagSet;
};
